var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"bold"},[_vm._v("ארעה שגיאה בשינוי הסטטוס, אנא שנה/י את הסטטוס של ה- Offer ידנית ועדכנ/י את עמית:")]),_c('offer-status',{attrs:{"payload":_vm.payload.offer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }